import React from 'react'
import UserSessionService from '../../../../services/user-session-service'
import useTopUserInfo from '../../../../hooks/useTopUserInfo'
import useActivityDates from '../../../../hooks/useActivityDates'
import { topNumber } from '../../../../constants/activity-constants'
import formatStringDate from '../../../../utils/formatStringDate'

import { callModal } from '../../modal-viewer/modal-store'
import { siteUrl } from '../../../../shared/utils/siteUrl'

import './current-player-info.scss'

function TopPositionInfo() {
  const userTop = useTopUserInfo()
  const point = userTop.userdata?.point || 0
  const position = userTop.userdata?.position || 0
  return (
    <div className="score-box-wrapper ">
      <div className="score-box">
        <span>Tus puntos</span>
        <h2>{point}</h2>
      </div>
      <div className="score-box">
        <span>Tu puesto</span>
        <h2>{position}</h2>
      </div>
    </div>
  )
}
function ActivityDateInfo() {
  const dates = useActivityDates()
  return <time dateTime={dates[1]}>{formatStringDate(dates[1])}</time>
}

export default function CurrentPlayerInfo() {
  const userInfo = UserSessionService.getUserInfo()
  const handlerCallCallLoginModal = () => {
    callModal('login', {
      onClose: (success: boolean) => {
        if (success) {
          window.location.reload()
        }
      },
    })
  }
  if (userInfo) {
    const name = userInfo?.name.split(' ')[0]
    return (
      <article className="f-current-player-info --logged">
        <h3 className="title-name capitalize">Hola {name}</h3>
        <TopPositionInfo />
        <p>
          Si no estás en nuestro top {topNumber} ¡sigue jugando y no te rindas!
          tienes hasta el <ActivityDateInfo /> para alcanzar los mejores
          puntajes.
        </p>
        <p>
          <b> ¡Participa y diviértete!</b>
        </p>
      </article>
    )
  }
  return (
    <article className="f-current-player-info">
      <p>
        <a
          className="link --login"
          rel="noopener noreferrer"
          onClick={handlerCallCallLoginModal}
        >
          Inicia sesión
        </a>{' '}
        para conocer tu puntaje y tu posición dentro del top de jugadoras.
      </p>

      <p>
        Si aún no formas parte de{' '}
        <a
          className="link --domain"
          rel="noopener noreferrer"
          href={siteUrl}
          target="__blank"
        >
          NosotrasOnline
        </a>
        <br />
        regístrate{' '}
        <a
          className="link --register"
          rel="noopener noreferrer"
          target="__blank"
          href={siteUrl + '/registro'}
        >
          aquí
        </a>
      </p>
      <p>
        <b>
          ¡Tú tienes el potencial para estar entre las {topNumber} mejores! Corre a
          participar.
        </b>
      </p>
    </article>
  )
}
